import {useEffect} from 'react';
import {useSelector} from 'react-redux';

import {isNil, isNotEmpty} from 'ramda';
import {isNotNil} from 'ramda-adjunct';

import {useGetBranchListQuery} from '@dms/api/core';
import {selectActiveBranchId} from '@dms/api/features';
import {useIsPublishingMultiBranchEnabledQuery} from '@dms/api/settings';
import {queryParams} from '@dms/shared';

import {useQueryState} from 'shared/web';

export function useAdvertisingPlatformBranchQuerySync() {
  const [branchId, setBranchId, clearBranchId] = useQueryState(queryParams.BRANCH_ID, true);
  const activeBranchId = useSelector(selectActiveBranchId);

  const {data: branchList, isLoading: isBranchListLoading} = useGetBranchListQuery();
  const {data: isMultiBranch} = useIsPublishingMultiBranchEnabledQuery();

  useEffect(
    function syncBranchIdQuery() {
      if (isBranchListLoading || isMultiBranch === undefined) {
        return;
      }

      if (isMultiBranch && isNotNil(branchList) && isNotEmpty(branchList.branchListItems)) {
        const isActiveBranchPresent = branchList.branchListItems
          .map((item) => item.id)
          .includes(activeBranchId);

        if (isNil(branchId)) {
          setBranchId(isActiveBranchPresent ? activeBranchId : branchList.branchListItems[0].id);
        }
      }

      if (!isMultiBranch && isNotNil(branchId)) {
        clearBranchId();
      }
    },
    [
      isMultiBranch,
      branchList,
      isBranchListLoading,
      branchId,
      activeBranchId,
      setBranchId,
      clearBranchId,
    ]
  );
}
